export function isElementAboveViewport(element, offset = 0) {
  if (!element) {
    return false;
  }

  const { bottom } = element.getBoundingClientRect();
  return bottom + offset <= 0;
}
